<script setup lang="ts">
import { EVENTS_ROUTES } from '@/router/routes'
import { EEventActions } from '@/store/eventStore/EventStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { defaultEventCreateModel, type EventCreateModel } from '@/types/models/EventCreateModel'
import { CreateButton, FullScreenLoader, StackLayout } from '@rfc/rfc-components-library'
import moment from 'moment'
import * as momentTz from 'moment-timezone'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import EventCreateInformations from './Create/EventCreateInformations.vue'

const store = useStore()

const router = useRouter()
const meData = computed(() => store?.state.authentication.me)
const loading = computed(() => store?.state?.event?.loading)

const data = ref<EventCreateModel>({
    ...defaultEventCreateModel,
    tz: meData.value?.data?.tz ?? momentTz.tz.guess()
})
const submitted = ref(false)

const updateData = (value: Partial<EventCreateModel>) => (data.value = { ...data.value, ...value })

const createEvent = () => {
    submitted.value = true
    if (errors.value.nameError || errors.value.startDateError || errors.value.endDateError) return
    store
        ?.dispatch(`${EStoreModules.EVENT}/${EEventActions.CREATE_EVENT}`, data.value)
        .then(res => (res.id ? router.push(EVENTS_ROUTES.buildUrl(res.id)) : null))
}

const errors = computed(() => ({
    nameError: submitted.value && !data.value.name,
    startDateError: submitted.value && !data.value.start_at,
    endDateError:
        submitted.value &&
        !!data.value.end_at &&
        moment(data.value.end_at).isBefore(data.value.start_at)
}))
</script>

<template>
    <FullScreenLoader :loading="!!loading" />
    <StackLayout direction="column" :gap="8">
        <CreateButton
            :loading="!!store?.state.event.loading"
            :label="$t('event.createEvent')"
            @click="createEvent" />
        <StackLayout direction="column" :gap="8">
            <EventCreateInformations
                :data="data"
                @update="updateData"
                :submitted="submitted"
                :hasErrors="errors" />
        </StackLayout>
    </StackLayout>
</template>
